import script from "./EstudioSocioEconomico.vue?vue&type=script&setup=true&lang=js"
export * from "./EstudioSocioEconomico.vue?vue&type=script&setup=true&lang=js"

import "./EstudioSocioEconomico.vue?vue&type=style&index=0&id=4d8131d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d8131d2"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QSpace,QBtn,QBtnGroup,QTooltip,QSpinnerDots});
